import { SharedImages } from '../assets/images';

type ImageErrorEvent = React.SyntheticEvent<HTMLImageElement, Event>;

export const handleImageError = (e: ImageErrorEvent): void => {
  const target = e.target as HTMLImageElement;
  target.onerror = null;
  target.src = SharedImages.profilePlaceholder.default;
};
